//----------------------------------------------Play Demo Button - Load Iframe Action-----------------------------------//
function autoPlayDemo( e ) {
    if (!e.target.closest('.button-play-for-free')) return;

    let element = e.target.closest('.button-play-for-free');
    let demoURL = element.dataset.iframeLink;
    let playBox = e.target.closest('.play-box');
    let iframe = playBox.querySelector('.iframe');
    playBox.classList.add('frame-active');
    playBox.querySelector('.iframe');
    iframe.innerHTML = `<iframe src="${demoURL}" frameborder="0" scrolling="no" allowtransparency="true" id="demo-iframe"></iframe>`;
    iframe.classList.add('show');
}

document.addEventListener('click', autoPlayDemo);